import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c8bce03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thumbnail-list" }
const _hoisted_2 = { class: "menu" }

import { PropType, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useLoadSlides from '@/hooks/useLoadSlides'
import { Mode } from '@/types/mobile'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import { Divider } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MobilePreview',
  props: {
  changeMode: {
    type: Function as PropType<(mode: Mode) => void>,
    required: true,
  },
},
  setup(__props) {



const { slides } = storeToRefs(useSlidesStore())
const { slidesLoadLimit } = useLoadSlides()

const mobileRef = ref<HTMLElement>()
const screenWidth = ref(0)

onMounted(() => {
  if (!mobileRef.value) return
  screenWidth.value = mobileRef.value.clientWidth
})

return (_ctx: any,_cache: any) => {
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_IconFullScreenPlay = _resolveComponent("IconFullScreenPlay")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-preview",
    ref_key: "mobileRef",
    ref: mobileRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "thumbnail-item",
          key: slide.id
        }, [
          _createVNode(ThumbnailSlide, {
            slide: slide,
            size: screenWidth.value - 20,
            visible: index < _unref(slidesLoadLimit)
          }, null, 8, ["slide", "size", "visible"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "menu-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.changeMode('editor')))
      }, [
        _createVNode(_component_IconEdit, { class: "icon" }),
        _createTextVNode(" 编辑")
      ]),
      _createVNode(_unref(Divider), {
        type: "vertical",
        style: {"height":"30px"}
      }),
      _createElementVNode("div", {
        class: "menu-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.changeMode('player')))
      }, [
        _createVNode(_component_IconFullScreenPlay, { class: "icon" }),
        _createTextVNode(" 播放")
      ])
    ])
  ], 512))
}
}

})